/**
 * Border Radius 토큰 — 4 단계
 */

export const radius = {
  sm: '6px',
  md: '8px',
  lg: '10px',
  xl: '14px',
  '2xl': '18px',
  full: '9999px',
} as const

export type RadiusKey = keyof typeof radius

export const getRadiusClass = (level: RadiusKey) =>
  `rounded-${level}` as const
